import { configureStore } from '@reduxjs/toolkit'

import websocketReducer from '../features/websocket/websocketSlice'
import classSelectionReducer from '../features/classSelection/classSlice'
import studentsReducer from '../features/classState/studentsSlice'
import canvasReducer from '../features/classCanvas/canvasSlice'
import behaviourControlsReducer from '../features/behaviourControls/behaviourControlsSlice'
import heatmapReducer from '../features/heatmap/heatmapSlice'
import weatherReducer from '../features/SessionSettings/WeatherSlice'
import ThemeSliceReducer from '../features/SessionSettings/ThemeSlice'
import ScenarioSliceReducer from '../features/SessionSettings/ScenarioSlice'
import DataCollectionReducer from '../features/SessionSettings/DataCollectionSlice'
import configurationReducer from '../features/ConfigurationContent/ConfigurationOptionsSlice'
import roomModuleReducer from '../features/ConfigurationContent/ConfigureRoomModulesSlice'
import presentationReducer from '../features/ConfigurationContent/ConfigurePresentationSlice'


export default configureStore({
    reducer: {
        websocket: websocketReducer,
        classSelection: classSelectionReducer,
        students: studentsReducer,
        canvas: canvasReducer,
        behaviourControls: behaviourControlsReducer,
        heatmap: heatmapReducer,
        weatherManager: weatherReducer,
        themes: ThemeSliceReducer,
        scenarios: ScenarioSliceReducer,
        dataCollection: DataCollectionReducer,
        configuration: configurationReducer,
        roomModules: roomModuleReducer,
        presentation: presentationReducer,
  },
});
